export const SET_START_BOOKING_REQUEST = "END/SET_START_BOOKING_REQUEST";
export const SET_START_BOOKING_SUCCESS = "END/SET_START_BOOKING_SUCCESS";
export const SET_START_BOOKING_FAIL = "END/SET_START_BOOKING_FAIL";

export const GET_START_BOOKING_REQUEST = "END/GET_START_BOOKING_REQUEST";
export const GET_START_BOOKING_SUCCESS = "END/GET_START_BOOKING_SUCCESS";
export const GET_START_BOOKING_FAIL = "END/GET_START_BOOKING_FAIL";
